var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"bg-gray pt-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }